import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import { Store } from './Store/Store';
import { RouterProvider } from 'react-router-dom';
import routes from './Routes';
import axios from 'axios';

//axios.defaults.baseURL="http://localhost:8000/";
axios.defaults.baseURL="https://hrbachatbazar.com/softwareapis/";
axios.defaults.headers.post['Content-Type']='application/json';
axios.defaults.headers.post['Accept']='application/json';
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.interceptors.request.use(function (config){
const token=localStorage.getItem('token');
config.headers.Authorization = token ? `Bearer ${token}` : '';

return config;

});
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
  <Provider store={Store}>
    
<RouterProvider router={routes}>

  </RouterProvider>

  </Provider>

  </React.StrictMode>
);

